import { Component } from '@angular/core';
import { membersuiteCreditLineItemEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'MemberSuite: Credit Line Items') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-membersuitecreditlineitem-form',
    templateUrl: './membersuitecreditlineitem.form.component.html'
})
export class membersuiteCreditLineItemFormComponent extends BaseFormComponent {
    public record!: membersuiteCreditLineItemEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

